import React from 'react';
import { useTheme } from 'styled-components';

const FileAttachmentIcon = ({ size = 32, color, ...props }) => {
  const theme = useTheme();
  const fill = color || (theme?.dark ? '#F3E6F4' : '#4A154B');
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6666 6.79331H11.74C10.16 6.79331 8.87329 5.50665 8.87329 3.92665V1.99998C8.87329 1.63331 8.57329 1.33331 8.20663 1.33331H5.37996C3.32663 1.33331 1.66663 2.66665 1.66663 5.04665V10.9533C1.66663 13.3333 3.32663 14.6666 5.37996 14.6666H10.62C12.6733 14.6666 14.3333 13.3333 14.3333 10.9533V7.45998C14.3333 7.09331 14.0333 6.79331 13.6666 6.79331Z"
        fill={fill}
      />
      <path
        d="M10.5333 1.47335C10.26 1.20002 9.78662 1.38668 9.78662 1.76668V4.09335C9.78662 5.06668 10.6133 5.87335 11.62 5.87335C12.2533 5.88002 13.1333 5.88002 13.8866 5.88002C14.2666 5.88002 14.4666 5.43335 14.2 5.16668C13.24 4.20002 11.52 2.46002 10.5333 1.47335Z"
        fill={fill}
      />
    </svg>
  );
};

export default FileAttachmentIcon;
